import { render, staticRenderFns } from "./pt-select-modal.vue?vue&type=template&id=6b27657c&"
import script from "./pt-select-modal.vue?vue&type=script&lang=js&"
export * from "./pt-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./pt-select-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports